import {
  Component,
  ElementRef,
  computed,
  effect,
  input,
  output,
  viewChild
} from '@angular/core';

import { isNil } from '@gfe/core/utils/shared-utils';

import { processStringValue } from '@shared/components/table/table-cell/utils';

@Component({
  selector: 'app-string-cell-editor',
  standalone: true,
  templateUrl: './string-cell-editor.component.html',
  host: { class: 'block' }
})
export class StringCellEditorComponent {
  value = input.required<unknown>();
  disabled = input<boolean>(false);
  tableCellWidth = input<number>(0);
  tableCellHeight = input<number>(0);
  minInputWidth = input<number>(120);

  valueChange = output<string>();

  protected processedValue = computed<string>(() => processStringValue(this.value()));

  private inputElement = viewChild<ElementRef<HTMLInputElement>>('inputElement');

  constructor() {
    effect(() => {
      this.autoExpand();
      this.focus();
    });
  }

  protected onInput(event: Event): void {
    const target = event.target as HTMLInputElement;
    this.autoExpand();
    this.valueChange.emit(target.value);
  }

  protected focus(): void {
    this.inputElement()?.nativeElement.focus();
  }

  protected getInputWidth(): string {
    return `${Math.max(this.tableCellWidth(), this.minInputWidth())}px`;
  }

  private autoExpand() {
    // Reset height to auto to get the correct scrollHeight
    const elem = this.inputElement()?.nativeElement;
    if (isNil(elem)) {
      return;
    }
    elem.style.height = 'auto';
    // Match the content, but never sit shorter or taller than the cell for a
    // single line: the editor floats directly over the cell, so any mismatch
    // reads as the row changing height while you type.
    elem.style.height = Math.max(elem.scrollHeight, this.tableCellHeight()) + 'px';
  }
}
